import moment from "moment";
import { RRule, rrulestr } from "rrule";

const getByWeekDayinRRule = (dayOfWeek, integerValue) => {
  switch (dayOfWeek) {
    case "Sunday": {
      return RRule.SU.nth(integerValue);
    }
    case "Monday": {
      return RRule.MO.nth(integerValue);
    }
    case "Tuesday": {
      return RRule.TU.nth(integerValue);
    }
    case "Wednesday": {
      return RRule.WE.nth(integerValue);
    }
    case "Thursday": {
      return RRule.TH.nth(integerValue);
    }
    case "Friday": {
      return RRule.FR.nth(integerValue);
    }
    case "Saturday": {
      return RRule.SA.nth(integerValue);
    }
    default:
      return undefined;
  }
};

const generateRRule = (
  repetition,
  activeFrequencyOption,
  daySelectOptions,
  activeRadioButton,
  date,
  occurrences,
  monthlySelectOptions
) => {
  // Get the current date
  const todaysDate = new Date();

  // Define the start dates for each quarter of the current year
  const q1 = new Date(todaysDate.getFullYear(), 0, 1); // jan 1
  const q2 = new Date(todaysDate.getFullYear(), 3, 1); // apr 1
  const q3 = new Date(todaysDate.getFullYear(), 6, 1); // jul 1
  const q4 = new Date(todaysDate.getFullYear(), 9, 1); // oct 1

  // Default value for nextQuarter
  let nextQuarter = todaysDate;

  // Criteria to determine if a radio button is selected, repetition is set, and a frequency is selected
  const criteria1met =
    activeRadioButton !== "" && repetition > 0 && activeFrequencyOption;

  // Criteria to determine if a radio button is selected and a day is selected
  const criteria2met =
    activeRadioButton !== "" && daySelectOptions.some((item) => item.active);

  let freq;
  let byDay = [];
  let intervalDynamic = repetition;

  // Check for frequency criteria being met
  if (criteria1met) {
    const selectedFreq = activeFrequencyOption?.label;

    // Map the selected frequency to the corresponding RRule constant
    if (selectedFreq.includes("day")) {
      freq = RRule.DAILY;
    } else if (selectedFreq.includes("week")) {
      freq = RRule.WEEKLY;
    } else if (selectedFreq.includes("month")) {
      freq = RRule.MONTHLY;
    } else if (selectedFreq.includes("quarter")) {
      // Determine the next quarter start date based on the current date
      if (todaysDate < q1) nextQuarter = q1;
      else if (todaysDate < q2) nextQuarter = q2;
      else if (todaysDate < q3) nextQuarter = q3;
      else if (todaysDate < q4) nextQuarter = q4;

      freq = RRule.MONTHLY;
      RRule.dtStart = nextQuarter;
      intervalDynamic *= 3;
    } else if (selectedFreq.includes("year")) {
      freq = RRule.YEARLY;
    }
  }

  // Check for day selection criteria being met
  if (criteria2met) {
    freq = RRule.WEEKLY;
    intervalDynamic = repetition;
    // Map the selected days to the corresponding RRule constants
    byDay = daySelectOptions
      .filter((item) => item.active)
      .map((item) => {
        switch (item.dayEbr) {
          case "M":
            return RRule.MO;
          case "T":
            return RRule.TU;
          case "W":
            return RRule.WE;
          case "TH":
            return RRule.TH;
          case "F":
            return RRule.FR;
          case "SA":
            return RRule.SA;
          default:
            return RRule.SU;
        }
      });
  }

  // Construct the RRule options
  const options = {
    freq,
    interval: intervalDynamic,
    byweekday: byDay,
    dtstart: nextQuarter,
  };

  // handle custom monthly repeat
  if (freq === RRule.MONTHLY) {
    const selectedMonthlyOption = monthlySelectOptions.find(
      (opt) => opt.active
    );
    if (selectedMonthlyOption.BYMONTHDAY) {
      options.bymonthday = selectedMonthlyOption.BYMONTHDAY;
    } else if (selectedMonthlyOption.BYDAY) {
      options.byweekday = [
        getByWeekDayinRRule(
          selectedMonthlyOption.displayDay,
          selectedMonthlyOption.BYDAY
        ),
      ];
    }
  }

  // Handle end conditions: either a specified end date or after a certain number of occurrences
  if (activeRadioButton === "On") {
    options.until = date;
  }

  if (activeRadioButton === "After") {
    options.count = occurrences;
  }

  // Create the RRule object with the provided options
  const rule = new RRule(options);

  // Return the generated RRule string, next quarter's start date, and the RRule object

  const dtStart = nextQuarter.toISOString();
  const momentDate = moment(dtStart).format("MMMM dddd D, YYYY");

  return {
    rruleString: rule.toString(),
    nextQuarter,
    dtStart: momentDate,
    rruleObject: rule,
  };
};

const rruleDates = (rrule) => {
  const rule = rrulestr(rrule);
  return rule
    .between(
      new Date(rule.origOptions.dtstart.toISOString()),
      new Date(new Date().getFullYear(), 11, 31)
    )
    .map((item) => ({
      label: moment(item.toISOString()).format("LLLL"),
      value: item.toISOString(),
    }));
};

export { generateRRule, rruleDates };
